var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BasePageHeader',{attrs:{"title":"編輯優惠券"}}),_c('el-card',[_c('CouponForm',{attrs:{"default-value":_vm.defaultValue},on:{"store":_vm.getCoupon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }